import styled from '@emotion/styled';
import React from 'react';
import { Typography } from '@mui/material';
import RClogo from "../assets/red-cat-logo.png";

// Define a styled component for the sidebar header
const StyledSidebarHeader = styled.div`
  height: 64px;
  min-height: 64px;
  display: flex;
  align-items: center;
  padding: 0 20px;

  > div {
    width: 100%;
    overflow: hidden;
  }
`;

// Define a styled component for the logo
const StyledLogo = styled.div`
  width: 35px;
  min-width: 35px;
  height: 35px;
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: white;
  font-size: 24px;
  font-weight: 700;
  background-color: #009fdb;
  background: linear-gradient(45deg, rgb(21 87 205) 0%, rgb(90 225 255) 100%);
  margin-left: ${props => (props.rtl ? '10px' : '4px')};
  margin-right: ${props => (props.rtl ? '4px' : '10px')};
`;

// Define the SidebarHeader functional component
export const SidebarHeader = ({ children, rtl, ...rest }) => {
  return (
    <>

{/* <div className='w-full flex justify-end mt-5 pr-3'>
<div className=' bg-white text-red-500 flex items-center justify-center' style={{borderRadius:"50%",height:"20px",width:"20px"}}>
          A
        </div>
   </div> */}

     
    <StyledSidebarHeader {...rest}>
   
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={RClogo} alt="" style={{ width: "2.5rem", }} />
        <Typography variant="h3" fontWeight={1700} color="red" marginLeft={1} marginTop={0.4}>
          RedCat
        </Typography>
        
      </div>
    
    </StyledSidebarHeader>
   
       
    </>
  );
};
